import type { AxiosInstance } from 'axios';

import type { TAutoAnomalyRowDto } from './types';

export class AutoAnomaliesApi {
  constructor(private readonly agent: AxiosInstance) {}

  fetchList(wellId: number, signal?: AbortSignal): Promise<TAutoAnomalyRowDto[]> {
    return this.agent
      .get<TAutoAnomalyRowDto[]>('/anomaly-registry/api/v1/anomalies/auto', {
        params: { wellId },
        signal,
      })
      .then((r) => r.data);
  }

  deleteRows(ids: string[], signal?: AbortSignal): Promise<void> {
    return this.agent
      .delete<void>('/anomaly-registry/api/v1/anomalies/auto', {
        data: { ids },
        signal,
      })
      .then((r) => r.data);
  }
}
